<template>


    <div>


        <div :id="'edit-issue-'+issue.id" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">

                <!-- Modal content-->
                <div class="modal-content modal-lg">
                    <div class="modal-header">
                        <button type="button" class="close"
                                data-dismiss="modal">&times;</button>


                        <div class="modal-title">
                            ویرایش Issue
                        </div>
                    </div>
                    <div class="modal-body">


                        <div class="row text-right">


                            <div class="col-12">



                                <div>

                                    <b-input
                                            v-model="issue.title" class="my-1 mt-2"
                                            placeholder="عنوان" rows="2" title="عنوان"
                                            :rules="rules"
                                    ></b-input>
                                    <b-textarea v-if="issue.title" title="توضیحات"
                                                v-model="issue.description" id="textarea-rows" class="my-1 mt-2"
                                                placeholder="توضیحات آیتم ..." rows="2"
                                                :rules="rules"
                                    ></b-textarea>


                                    <b-row  v-if="issue.title">




                                        <b-col  md="3">
                                            <small> نوع:</small>

                                            <b-form-select v-model="issue.type"  size="sm" class="mt-2" style="direction: ltr">

                                                <b-form-select-option  v-for="(type, typeIndex) in types" :key="typeIndex"  :style="{color: typeBadgeStyles(type)}"
                                                                       :value="type.id"  >
                                                    {{type.title}}
                                                </b-form-select-option>

                                                <b-form-select-option  value="0" style="color: #888888">سایر</b-form-select-option>

                                            </b-form-select>
                                        </b-col>

                                        <b-col  md="4">
                                            <small> وضعیت:</small>

                                            <b-form-select
                                                    v-c-tooltip="{
        content: '<strong>وضعیت</strong>',
        placement: 'left'
      }"
                                                    v-model="issue.board_id"  size="sm" class="mt-2"  style="direction: ltr">

                                                <b-form-select-option  value="1"  style="color: #ffab00">(Open) باز شده</b-form-select-option>
                                                <b-form-select-option  value="2"  style="color: #ffd600">(To DO) جهت انجام</b-form-select-option>
                                                <b-form-select-option  value="3"  style="color: #aeea00">درحال انجام (Doing)</b-form-select-option>
                                                <b-form-select-option  value="4"  style="color: #00bfa5">انجام شده (Done)</b-form-select-option>
                                                <!--                                                          <b-form-select-option  value="4"  style="color: #64dd17">جهت بازبینی (Review)</b-form-select-option>-->
                                                <b-form-select-option  value="5"  style="color: #64dd17">آرشیو (Archived)</b-form-select-option>




                                            </b-form-select>
                                        </b-col>

                                        <b-col  md="3">
                                            <small> اولویت:</small>

                                            <b-form-select title="اولویت" v-model="issue.priority"  size="sm" class="mt-2"  style="direction: ltr">

                                                <b-form-select-option  value="3" >  اولویت زیاد</b-form-select-option>
                                                <b-form-select-option  value="2" >  اولویت متوسط</b-form-select-option>
                                                <b-form-select-option  value="1" >  اولویت کم</b-form-select-option>



                                            </b-form-select>
                                        </b-col>

                                      <b-col  md="2">
                                        <small> سرشاخه:</small>
                                        <b-input v-model="issue.parent_id" type="number"  size="sm" class="mt-2" ></b-input>
                                      </b-col>

                                        <!--                                                  <b-col  md="5" class="mt-3 mb-2">-->
                                        <!--                                                      &lt;!&ndash;                                                          <b-form-select v-model="issue.type"  size="sm" class="mt-2"  style="direction: ltr">&ndash;&gt;-->
                                        <!--                                                      &lt;!&ndash;                                                              <b-form-select-option  value="null" >پروژه نامشخص</b-form-select-option>&ndash;&gt;-->
                                        <!--                                                      &lt;!&ndash;                                                          </b-form-select>&ndash;&gt;-->

                                        <!--                                                      <multiselect v-model="issue.project_id"  @select="setForumId($event)"  :options="options"-->
                                        <!--                                                                   placeholder=" انتخاب پروژه" label="title" track-by="title">-->
                                        <!--                                                      </multiselect>-->
                                        <!--                                                  </b-col>-->



                                        <b-col  md="12" class="mt-3 mb-2">
                                            <small> اختصاص کاربر:</small>

                                            <multiselect   v-model="issue.users" :height="300" :options="assignOptions" :multiple="true"
                                                           :taggable="true" :close-on-select="false" :clear-on-select="false"
                                                           :custom-label="customLabelAssign"
                                                           :preserve-search="true" :hide-selected="true" :show-labels="false"
                                                           tag-placeholder="اختصاص کاربر" placeholder="اختصاص کاربر"
                                                           label="name" track-by="name" :preselect-first="false"
                                                           @tag="addAssign">

                                            </multiselect>
                                        </b-col>



                                      <b-col  md="6" class="mb-2">

                                        <small> فرایند:</small>
                                        <b-form-select  size="sm" style="direction: ltr"
                                                        v-model="issue.process_id"
                                        >
                                          <b-form-select-option  v-for="(process, processIndex) in processes" :key="processIndex"
                                                                 :value="process.id"  >
                                            {{process.title}}
                                          </b-form-select-option>

                                        </b-form-select>
                                      </b-col>
                                      <b-col  md="6" class="mb-2" >

                                        <small> مرحله:</small>
                                        <b-form-select  size="sm" style="direction: ltr"
                                                        v-model="issue.step_id"
                                        >
                                          <b-form-select-option  v-for="(step, stepIndex) in steps" :key="stepIndex"   :value="step.id" >
                                            {{step.title}}
                                          </b-form-select-option>

                                        </b-form-select>
                                      </b-col>

                                      <!--                                      <b-col  md="12" class="mt-2">-->
                                      <!--                                        <br><hr>-->
                                      <!--                                      </b-col>-->


                                      <b-col v-if="issue.fields"  md="3" sm="12" class="mt-2 mb-3"  v-for="(field, fieldIndex) in returnIssueFields(issue.fields, issue.field_values, issue.type_object)" :key="fieldIndex" >

                                        <small v-if="field.type !== 'space'">{{field.title}}:</small>

                                        <b-input v-if="field.type === 'input'"
                                                 v-model="field.pivot.value"
                                                 :placeholder="field.title"
                                                 type="text"
                                                 size="sm"
                                                 :disabled="checkIntersection(pluck(roles, 'name'), field.access_owners)"
                                        ></b-input>
                                        <b-input v-else-if="field.type === 'input-number'"
                                                 v-model="field.pivot.value"
                                                 :placeholder="field.title"
                                                 type="number"
                                                 size="sm"
                                                 :disabled="checkIntersection(pluck(roles, 'name'), field.access_owners)"
                                        ></b-input>
                                        <!--                                          <small> </small>-->
                                        <custom-time-picker v-else-if="field.type === 'date'"
                                                            v-model="field.pivot.value"  :lable="field.title"
                                                            type="date" :clearable="true" :placeholder="field.title" min="" max=""
                                                            size="sm" input-class="form-control form-control-sm"
                                                            :disabled="checkIntersection(pluck(roles, 'name'), field.access_owners)"
                                        >
                                        </custom-time-picker>
                                        <custom-time-picker v-else-if="field.type === 'datetime'"
                                                            v-model="field.pivot.value"  :lable="field.title"
                                                            type="datetime" :clearable="true" :placeholder="field.title" min="" max=""
                                                            size="sm" input-class="form-control form-control-sm"
                                                            :disabled="checkIntersection(pluck(roles, 'name'), field.access_owners)"
                                        >
                                        </custom-time-picker>


                                        <b-form-select v-else-if="field.type === 'option-true-false'"  size="sm"
                                                       v-model="field.pivot.value" style="direction: ltr"
                                                       :disabled="checkIntersection(pluck(roles, 'name'), field.access_owners)"
                                        >
                                          <b-form-select-option value="1"> تأیید</b-form-select-option>
                                          <b-form-select-option value="0">عدم تأیید </b-form-select-option>
                                        </b-form-select>
                                        <b-form-checkbox v-else-if="field.type === 'check-box'"  size="sm"
                                                         v-model="field.pivot.value" style="direction: ltr">
                                        </b-form-checkbox>



                                        <b-form-select v-else-if="field.type === 'option'"  size="sm"
                                                       v-model="field.pivot.value" style="direction: ltr"
                                                       :disabled="checkIntersection(pluck(roles, 'name'), field.access_owners)"
                                        >
                                          <b-form-select-option  v-for="(option, optionIndex) in JSON.parse(field.options)" :key="optionIndex"
                                                                 :value="option.value">
                                            {{option.title}}
                                          </b-form-select-option>
                                        </b-form-select>
                                        <b-form-radio-group
                                            v-else-if="field.type === 'radio'"
                                            v-model="field.pivot.value"
                                            :name="field.title"
                                            :disabled="checkIntersection(pluck(roles, 'name'), field.access_owners)"
                                        >
                                          <b-form-radio  v-for="(option, optionIndex) in JSON.parse(field.options)" :key="optionIndex" :value="option.value">
                                            {{option.title}}
                                          </b-form-radio>
                                        </b-form-radio-group>


                                        <b-form-textarea v-else-if="field.type === 'textarea'"  size="sm" v-model="field.pivot.value"
                                                         :disabled="checkIntersection(pluck(roles, 'name'), field.access_owners)"
                                        ></b-form-textarea>

                                        <br v-else-if="field.type === 'space'">

                                      </b-col>





                                    </b-row>

                                </div>


                              <b-col class="px-0"  title="نمایش سایر فیلد ها">
                                <b-button  @click="moreDetailShow = !moreDetailShow"  size="sm">
                                  <i class="fas fa-bars" aria-hidden="true"></i>
                                </b-button>
                              </b-col>


                                <b-card v-if="issue.title && moreDetailShow">
                                    <!--                                                          <b-form-select v-model="selected" :options="typeOptions" size="sm" class="mt-3"></b-form-select>-->



                                    <b-row  >




                                      <b-col  md="3">
                                            <small> زمان شروع:</small>
                                            <custom-time-picker  v-model="issue.start_date"
                                                                 type="datetime" :clearable="true" placeholder="زمان شروع" min="" max="">
                                            </custom-time-picker>
                                        </b-col>
                                        <b-col  md="3">
                                            <small> زمان انجام:</small>
                                            <custom-time-picker  v-model="issue.done_date"
                                                                 type="datetime" :clearable="true" placeholder="زمان انجام" min="" max="">
                                            </custom-time-picker>
                                        </b-col>

                                        <b-col  md="3" >
                                            <small> مدت تخمینی:</small>
                                            <b-input
                                                    v-model="issue.estimated_time"
                                                    placeholder=" مدت تخمینی (ساعت)"
                                                    type="number"
                                            ></b-input>
                                        </b-col>

                                        <b-col  md="3" >
                                            <small> درصد پیشرفت:</small>
                                            <b-input
                                                    v-model="issue.progress_input"
                                                    placeholder="درصد پیشرفت"
                                                    type="number"
                                            ></b-input>
                                        </b-col>




                                      <b-col  md="6" class="mt-3 mb-2">
                                        <small> مشتری:</small>

                                        <v-select
                                            v-model="issue.contact_id"
                                            :options="contacts" label="last_name" :reduce="contact => contact.id" value="id">
                                        </v-select>


                                        <!--                            <multiselect  v-model="contact_id"  @select="setContactId()"    :options="contactOptions" :custom-label="customLabel"-->
                                        <!--                                         placeholder=" انتخاب مشتری" label="title" track-by="title">-->
                                        <!--                            </multiselect>-->
                                      </b-col>

                                      <b-col  md="6" class="mt-3 mb-2">
                                        <small> پروژه:</small>

                                        <v-select
                                            v-model="issue.project_id"
                                            :options="projects" label="title" :reduce="project => project.id" value="id">
                                        </v-select>

                                      </b-col>



                                        <b-col  md="12" class="mt-2">

                                            <multiselect  v-model="issue.tags" :height="300" :options="options" :multiple="true"
                                                          :taggable="true" :close-on-select="false" :clear-on-select="false"
                                                          :custom-label="customLabel"
                                                          :preserve-search="true" :hide-selected="true" :show-labels="false"
                                                          tag-placeholder="افزودن تگ جدید" placeholder="برچست (تگ)"
                                                          label="title" track-by="title" :preselect-first="false"

                                                          @tag="addTag">
                                            </multiselect>
                                        </b-col>



                                    </b-row>


                                </b-card>



                                <b-card v-if="issue.title && moreDetailShow">
                                    <b-row>
                                        <b-col md="4" class="text-right text-sm">

                                            <h6>پیوست فاکتور/سند مالی:</h6>
                                        </b-col>
                                        <b-col md="2" class="text-left text-sm">

                                            <router-link data-dismiss="modal"  v-if="issue.order_id && issue.order_id != 'null' && issue.order" :to="{path: '/order/payment/'+issue.order_id, params: {id: issue.order_id}}"
                                                         class="btn btn-sm btn-pill btn-info">
                                                فاکتور:

                                                {{issue.order.id}}
                                            </router-link>
                                        </b-col>

                                        <b-col  v-if="role == 'superadministrator' || issue.created_by ==  authUser.id"  md="4">

                                          <b-input type="number" v-model="issue.order_id"></b-input>

                                        </b-col>
                                        <b-col  md="2">
                                            <b-btn  v-if="role == 'superadministrator' || issue.created_by ==  authUser.id" size="sm" @click="addOrder(issue.id ,issue.order_id)">پیوست فاکتور</b-btn>
                                        </b-col>

                                    </b-row>
                                </b-card>
                            </div>

                        </div>

                    </div>
                    <div class="modal-footer">


                        <button @click="editIssue(issue)" type="button" class="btn btn-success"
                                data-dismiss="modal" >ثبت</button>

                        <button type="button" class="btn btn-default"
                                data-dismiss="modal" >بستن</button>

                    </div>
                </div>

            </div>
        </div>




    </div>



</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

import Multiselect from 'vue-multiselect'

export default {
  name: 'editIssue',
  components: {

      Multiselect,

  },


    props: {
        issue: null,
        editIssueState: false

    },


  data () {
    return {

        auth: {
            headers: {
                Authorization: 'bearer ' + localStorage.getItem('token')
            }
        },


        role: localStorage.getItem('role'),
        roles: JSON.parse(localStorage.getItem('roles')),
        authUser:
            {
                id:localStorage.getItem('id'),
            },



        loadMore: true,
        page: 1,
        pageSize: 10,
        voice: '',

        issues:[],
        issueText: 0,
        newIssue: {
            intro:'',
            state:'0',
            title:'',
            text:'0',


            progress_input:'',

            voice:'',
            file:'',
            image:'',
            video:'',

            news:0,
            course_id:null,
            course_category_id:null,
            forum_id:null,
            forum_category_id:null,
            fileLib_tags:null,
            // issue_likes:null,
            // userLike:null,

            type:'ticket',
            project_id:null,
            board_id:2,
            users:[],

            priority:2,
            start_date:null,
            due_date:null,
            tags:[],

            // parent_id:null

        },
        rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

        showVoiceRecorder: false,
        showFileUploader: false,
        showImageUploader: false,
        showVideoUploader: false,

        src: null,
        srcPlay: null,

        issueAsCourse: false,
        issueAsForum: false,

        courseDisabled: false,
        forumDisabled: false,

        newComment:'',
        newReply:'',

        options:[],

        selectedTags: [],
        tags: [],
        isLoading: false,



        typeOptions: [
            { value: 'ticket', text: 'پیگیری (Ticket)' , selected :true},
            { value: 'bug', text: 'ایراد (Bug)' },
            { value: 'task', text: 'فعالیت (Task)' },
            { value: 'story', text: 'لیست (Story)' },
            { value: 'epic', text: 'نسخه/فیچر (Epic)' },
            { value: 'lead', text: 'سرنخ/فرصت (Lead)' },
            { value: 'meeting', text: 'ملاقات/جلسه/رویداد' },

        ],


        warningModal: false,

        contact_id: '',
        contacts: [],
        projects: [],



        users:[],

        steps: [],
        orders: [],
        processes: [],

        types: [],

        assignOptions:[],


      moreDetailShow:false,


    }
  },


    watch: {

        editIssueState: function () {

            if (this.editIssueState === true)
                 this.getBaseData()

        },

        issue: {
            deep: true,
            handler() {

                this.getSteps(this.issue.process_id)

            }
        }

        },




    mounted() {




    },



    methods: {


        getBaseData(){
            this.getTypes()
            this.getProcesses()
            this.getSteps()
            this.getProjects()
            this.getOrders()
            this.getContacts()
            this.getUsers()
        },

        pluck(array, key) {
            return array.map(function (obj) {
                return obj[key];
            });
        },

        customLabel(option) {
            //   console.log(option.title)

            //   this.item.tags.push(option)
            return `${option.title}`

        },

        addTag (newTag) {
            // const tag = {
            //     name: newTag,
            //     code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            // }
            // this.options.push(tag)
            // this.value.push(tag)

            this.options.push({
                title: '#'+newTag,
                id: 0
            })
        },

        ajaxFindTag(query){

        },

        limitText (count) {
            return `and ${count} other tags`
        },

        asyncFind (query) {
            this.isLoading = true
            this.ajaxFindTag(query).then(response => {
                this.tags = response
                this.isLoading = false
            })
        },

        clearAll () {
            this.selectedTags = []
        },

        getProcesses(){
            var app = this;
            axios.get('/api/intro/processes', app.auth)
                .then(function (response) {
                    app.processes = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getSteps(processID = null){
            var app = this;
            axios.get('/api/intro/steps/'+processID ,  app.auth)
                .then(function (response) {
                    app.steps = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getOrders(){

            axios.get('/api/orders', this.auth)
                .then(response => {
                    // this.current_page = response.data.current_page
                    this.orders = response.data.data;
                    // this.pagnationDate = response.data
                    // console.log(this.pagnationDate)
                    // this.loader = false
                })
                .catch(error => {
                    // this.loader = false
                    console.log(error);
                })
        },

        getContacts(){

            axios.get('/api/contactslist', this.auth)
                .then(response => {
                    // this.current_page = response.data.current_page
                    this.contacts = response.data;
                    // this.pagnationDate = response.data
                    // console.log(this.pagnationDate)
                    // this.loader = false

                    this.makeContactOptions()

                })
                .catch(error => {
                    // this.loader = false
                    console.log(error);
                })
        },

        makeContactOptions(){
            var app = this;

            for (const key in app.contacts) {
                if (app.contacts.hasOwnProperty(key)) {
                    const element = app.contacts[key];

                    app.contactOptions.push({
                        value: element.id,
                        text: element.first_name+' '+element.last_name
                    })
                    // this.details[0].
                }
            }
            // console.log(app.contacts)
            // console.log(app.contactOptions)


        },

        getProjects() {
            axios
                .get('/api/projectList', this.auth)
                .then(response => {

                    this.projects = response.data;
                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
        },



        addOrder(issueId ,orderId){

            var app = this;

            var params= {
                order_id: orderId,
                // state: state,
            }

            axios.post(`/api/issue/addOrder/`+issueId,  params , app.auth)
                .then(function (resp) {
                    console.log(resp,"")
                    // app.items.push(app.timing);
                    app.$snotify.success(' با موفقیت ثبت شد');

                    app.getStepsWithIssues()
                })
                .catch(
                    e => {
                        console.log(e);
                        app.$snotify.error('امکان ثبت وجود ندارد');
                    }
                );


        },

        changeContact(issueId ,contactId){

            var app = this;

            var params= {
                contact_id: contactId,
                // state: state,
            }

            axios.post(`/api/issue/changeContact/`+issueId,  params , app.auth)
                .then(function (resp) {
                    console.log(resp,"")
                    // app.items.push(app.timing);
                    app.$snotify.success(' با موفقیت ثبت شد');

                    app.getStepsWithIssues()
                })
                .catch(
                    e => {
                        console.log(e);
                        app.$snotify.error('امکان ثبت وجود ندارد');
                    }
                );


        },

        setContactId(){

            // console.log(event)

            // this.newPost.contact_id = event.value
            this.newPost.contact_id = this.contact_id

            console.log(this.newPost.contact_id)
        },



        onResult (data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
            this.srcPlay =  window.URL.createObjectURL(data)
            this.src =  data

        },

        editIssue(issue) {
            var app = this;

            if (issue.title.length > 100 || issue.description.length > 300){
                app.$snotify.error('تعداد حروف بیشتر از  کاراکتر مجاز است! متن رو کوتاه تر نمایید. ');
            }else {


                console.log('issue.fields',issue.fields, issue.field_values, issue.type_object);
                if (issue.fields && issue.field_values)
                    issue.fieldWithVariable = JSON.stringify(app.returnIssueFields(issue.fields, issue.field_values, issue.type_object))
                else
                    issue.fieldWithVariable = []

                if(issue.users){
                    if(issue.users.length !==0){
                        issue.users = app.pluck(issue.users,"id")
                    }
                }

                if(issue.tags){
                    issue.tagsArray = []
                    if(issue.tags.length !==0){
                        issue.tagsArray = app.pluck(issue.tags,"title")
                    }
                }



                var newItem = issue;
                let formData = new FormData();
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        formData.append(key, element)
                        console.log(key, element);
                    }
                }

                axios.post(`/api/intro/editIssue/`+issue.id,  formData , app.auth)
                    .then(function (resp) {
                        app.$snotify.success('ویرایش پست (Issue) با موفقیت انجام شد');


                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            app.$snotify.error('امکان ویرایش پست (Issue) وجود ندارد');
                        }
                    )
                    .finally(
                        f => {
                            app.$parent.getIssues() //need to consider

                        }
                    );

            }
        },


        returnIssueFields(fields, field_values , type_object){

            var combinedFieldAndValue = []
            if (field_values.length !== 0){
                if (type_object)
                    combinedFieldAndValue = _.map(field_values, function(item){
                        return _.extend(item, _.find(type_object.fields , { id: item.id, value: item.value }));
                    });
                else
                    combinedFieldAndValue = field_values
            }else {
                if (type_object)
                    combinedFieldAndValue = _.map(type_object.fields, function(item){
                        return _.extend(item, _.find(field_values , { id: item.id, value: item.value }));
                    });
                else
                    combinedFieldAndValue = []
            }


            combinedFieldAndValue.forEach(function (element) {
                if (!element.pivot.value)
                    element.pivot.value = '';
            });

            return combinedFieldAndValue
        },

        getTags(){
            var app = this;
            axios.get('/home/file/tagSearch/', app.auth)
                .then(function (response) {
                    app.fileCategories = response.data.data.tags.data

                    console.log(response.data.data.tags.data)


                    for (const key in app.fileCategories) {
                        if (app.fileCategories.hasOwnProperty(key)) {
                            const element = app.fileCategories[key];

                            app.options.push({
                                title: '#'+element.title,
                                id: element.id
                            })
                            // this.details[0].
                        }
                    }
                    // console.log(app.options)


                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },





        getUsers(){
            var app = this;
            axios.get('/api/userslist', app.auth)
                .then(function (response) {
                    app.users = response.data

                    console.log('users',response.data)


                    for (const key in app.users) {
                        if (app.users.hasOwnProperty(key)) {
                            const element = app.users[key];

                            app.assignOptions.push({
                                name: '@'+element.name,
                                id: element.id
                            })
                        }
                    }

                    app.setAssignedUsers(app.issue.assigned_users)

                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        setAssignedUsers(assigned_users){
            var app = this;
            // console.log('setAssignedUsers',assigned_users)
            // if (assigned_users.length !== 0)
            assigned_users.forEach(function (element) {
                // console.log('setAssignedUser',element.name,app.issue)
                // app.issue.users = []
                // app.issue.users.push({
                //     id: element.id,
                //     title: '@'+element.name
                // })
            });


        },



        customLabelAssign(option) {

            return `${option.name}`

        },

        addAssign (newTag) {

            this.assignOptions.push({
                name: '@'+newTag,
                id: 0
            })
        },




        getTypes(){
            var app = this;
            axios.get('/api/issueTypeList', app.auth)
                .then(function (response) {
                    app.types = response.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },


        typeBadgeStyles(issueType){
            if (issueType.type == 1)
                return '#880e4e'
            else if (issueType.type == 2)
                return '#f50057'
            else if (issueType.type == 3)
                return '#8e24aa'
            else if (issueType.type == 4)
                return '#263238'
            else if (issueType.type == 5)
                return '#dd2c00'
            else if (issueType.type == 6)
                return '#00c853'
            else if (issueType.type == 7)
                return '#0097a7'
            else if (issueType.type == 8)
                return '#0288d1'
            else if (issueType.type == 9)
                return '#0208ff'
            else if (issueType.type == 10)
                return '#eeb600'
            else if (issueType.type == 10)
                return '#0e8e2e'
            else
                return '#888888'
        },

      intersection(array1,array2){
        var arr = [];
        // var arr2 = array2.toString().split(',').map(Number);
        var arr1 = []
        if (array1)
          arr1 = array1
        var arr2 = []
        if (array2)
          arr2 = array2
        // for array1
        for (var i in arr1) {
          if(arr2.indexOf(arr1[i]) != -1)
            arr.push(arr1[i]);
        }
        return arr.sort((x,y) => x-y);
      },

      checkIntersection(array1,array2){
         if(this.intersection(array1, array2).length)
           return false
         else
           return true
      },






    }
}
</script>











<style scoped>


    tr{
        box-shadow: 0px 4px 4px rgba(0,0,0,.15);

    }



</style>
